import { Component } from 'vue-property-decorator';
import { Block } from '@/helpers/components';
import { BaseBlock } from '@/blocks/base-block';
import { WmsUserDTO } from '../../../model/WmsUserDTO';

enum LoginState {
	NotLoggedIn = 0,
	LoggedIn = 1,
	Unknown = 2
}

@Block() @Component
export class FavoriteProductsHeadingBlock extends BaseBlock {
	loginState: LoginState = LoginState.Unknown;

	email: string = "";
	password: string = "";

	userInfo: WmsUserDTO;

	created() {
		this.getUserInfo();

		this.$root.$on("user-changed", (par: string) => this.getUserInfo());
	}

	getUserInfo() {
		this.loginState = LoginState.Unknown;	// needed to correctly update userInfo after user info change (via form)
		this.$userService.getUserInfo()
			.then(ui => {
				this.userInfo = ui;
				this.loginState = LoginState.LoggedIn;
			})
			.catch(error => {
				this.loginState = LoginState.NotLoggedIn;
			})
	}

	get notLoggedIn(): boolean {
		return this.loginState == LoginState.NotLoggedIn;
	}

	get loggedIn(): boolean {
		return this.loginState == LoginState.LoggedIn;
	}
	
	loginUser() {
		this.$userService.postLogin(this.email, this.password)
			.then(_ => {
				this.email = this.password = "";
				this.$root.$emit("user-changed", "login");
			})
			.catch(err => {
				alert(this.getText("login-failed"))
			})
		
	}

	logoutUser() {
		this.$userService.postLogout()
			.then(_ => {
				this.$cookiesService.setFavoriteProducts([]);
				this.$root.$emit("user-changed", "logout");
			})
	}

	registerUser() {
		this.$root.$emit("user-reg-form-called");
	}

	changeUser() {
		this.$root.$emit("user-edit-form-called");
	}
}

export default FavoriteProductsHeadingBlock;
